export default {
  baseStyle: {
    _hover: {
      textDecoration: "none",
    },
  },

  sizes: {},

  variants: {
    "link-nav": {
      color: "btn-green-bg",
      textDecoration: "underline",
      textDecorationThickness: "2px",
      textUnderlineOffset: "6px",
      lineHeight: 1.2,
      fontSize: "14px",
      letterSpacing: "semitight",
      _hover: {
        color: "grey-0",
        textDecoration: "underline",
        textDecorationThickness: "2px",
        textUnderlineOffset: "6px",
      },
    },
    blue: {
      color: "text-primary",
    },
    //underline
    "link-secondary": {
      lineHeight: 1.1,
      borderRadius: "none",
      bg: "transparent",
      color: "text-primary",
      paddingX: 0,
      display: "inline",
    },
    "link-blog": {
      fontWeight: "normal",
      color: "bg-primary-active",
    },
  },

  defaultProps: {},
};
